<template>
    <div class="globalViewNotification" :class="{ 'dark': this.dark }">
        <div class="title">
            <h3>Notificações</h3>
            <div class="title-actions" v-if="data.length > 0">
                <v-btn 
                    color="primary" 
                    variant="outlined" 
                    size="small"
                    @click="markAllAsRead"
                    :loading="markingAllAsRead"
                >
                    <v-icon start>mdi-check-all</v-icon>
                    Marcar todas como lidas
                </v-btn>
            </div>
        </div>
        <div class="intenNotification" v-if="data.length > 0">
            <v-expansion-panels variant="accordion" v-model="active" @update:modelValue="onPanelChange">
                <v-expansion-panel v-for="(item, index) in data" :key="item.id" :value="index" :class="{ 'read-notification': item.isRead === 1 }">

                  <v-expansion-panel-title expand-icon="mdi-menu-down" >
                    <div class="title_accordion">
                      <span>{{item.title}}</span>
                      <div class="notification-status">
                        <span class="count">{{ formatDate(item.dateInsert) }}</span>
                        <v-icon v-if="item.isRead === 1" color="success" size="small" class="read-icon">mdi-check-circle</v-icon>
                      </div>
                    </div>
                  </v-expansion-panel-title>
            
                  <v-expansion-panel-text class="content">
                    <div class="notification-content-wrapper">
                      <div class="notification-description" v-html="item.description"></div>
                      <div class="notification-footer">
                        <div class="notification-actions">
                          <v-btn 
                            v-if="item.isRead === 0"
                            variant="text" 
                            color="primary" 
                            size="small"
                            class="action-btn"
                            @click="markAsRead(item.id)"
                            :loading="markingAsRead === item.id"
                          >
                            <v-icon start>mdi-check</v-icon>
                            Marcar como lida
                          </v-btn>
                        </div>
                        <div class="notification-meta">
                          <span class="notification-date">{{ formatDate(item.dateInsert) }}</span>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-text>
        
                </v-expansion-panel>
              </v-expansion-panels>
        </div>
        <div class="noNotification" v-else>
            <h3>Nenhuma notificação</h3>
        </div>
    </div>
    
</template>

<script>
import api from '@/utils/portal/notification.js'
import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';


export default {
    data(){
        return{
            active: 0,
            data:[],
            markingAsRead: null,
            markingAllAsRead: false,
            readNotifications: new Set() // Para controlar quais já foram marcadas como lidas
        }
    },
    props:{

    },
    computed:{
        ...mapState(['token','dark','user'])
    },
    methods:{
        async getDataNotification(){
            try {
                const response = await api.getDataNotifications(this.token);
                
                // Filtrar apenas notificações com status ativo (status === 1)
                const filteredNotifications = response.filter(notification => {
                    return notification.status === 1;
                });
                
                this.data = filteredNotifications;
                
                // Inicializar controle de notificações lidas baseado no campo isRead da API
                filteredNotifications.forEach(notification => {
                    if (notification.isRead === 1) {
                        this.readNotifications.add(notification.id);
                    }
                });
            } catch (error) {
                toast.error('Erro ao carregar notificações');
                console.error('Erro na listagem da notificações')
            }   
        },
        async readNotification(id) {
            try {
                const payload = {
                    "idNotification": id,
                    "idUser": this.user?.id || null,
                }
                await api.readNotification(this.token, payload);
                this.readNotifications.add(id);
                return true;
            } catch (error) {
                console.error('Erro ao marcar notificação como lida:', error);
                throw error;
            }
        },
        async markAsRead(id) {
            if (!id) return;
            
            // Encontrar a notificação no array
            const notification = this.data.find(item => item.id === id);
            if (!notification || notification.isRead === 1) return;
            
            this.markingAsRead = id;
            try {
                await this.readNotification(id);
                
                // Atualizar o campo isRead na notificação
                notification.isRead = 1;
                
                toast.success('Notificação marcada como lida');
                // Disparar evento customizado para atualizar contador de notificações
                window.dispatchEvent(new CustomEvent('notification-read'));
            } catch (error) {
                toast.error('Erro ao marcar notificação como lida');
            } finally {
                this.markingAsRead = null;
            }
        },
        async markAllAsRead() {
            this.markingAllAsRead = true;
            try {
                const unreadNotifications = this.data.filter(notification => notification.isRead === 0);
                
                if (unreadNotifications.length === 0) {
                    toast.info('Todas as notificações já foram marcadas como lidas');
                    return;
                }
                
                // Marcar todas em paralelo
                const promises = unreadNotifications.map(notification => this.readNotification(notification.id));
                await Promise.all(promises);
                
                // Atualizar o campo isRead para todas as notificações
                unreadNotifications.forEach(notification => {
                    notification.isRead = 1;
                });
                
                toast.success(`${unreadNotifications.length} notificação(ões) marcada(s) como lida(s)`);
                // Disparar evento customizado para atualizar contador de notificações
                window.dispatchEvent(new CustomEvent('notification-read'));
            } catch (error) {
                toast.error('Erro ao marcar notificações como lidas');
            } finally {
                this.markingAllAsRead = false;
            }
        },
        onPanelChange(panelIndex) {
            // Marcar como lida quando o painel for expandido
            if (panelIndex !== null && panelIndex !== undefined) {
                const notification = this.data[panelIndex];
                if (notification && notification.id && notification.isRead === 0) {
                    this.markAsRead(notification.id);
                }
            }
        },
        formatDate(dateString) {
            if (!dateString || dateString === null) return 'Data não disponível';
            
            const date = new Date(dateString);
            
            // Verificar se a data é válida
            if (isNaN(date.getTime())) {
                return 'Data inválida';
            }
            
            const now = new Date();
            const diffInMs = now - date;
            const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
            const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
            const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
            
            if (diffInMinutes < 1) {
                return 'Agora mesmo';
            } else if (diffInMinutes < 60) {
                return `${diffInMinutes} min atrás`;
            } else if (diffInHours < 24) {
                return `${diffInHours}h atrás`;
            } else if (diffInDays === 1) {
                return 'Ontem';
            } else if (diffInDays < 7) {
                return `${diffInDays} dias atrás`;
            } else {
                return date.toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            }
        }
    },
    created() {
        this.getDataNotification();
    },
}
</script>

<style >
.globalViewNotification {
    background-color: #f9f9f9fc;
    height: calc(100% - 120px);
    padding: 50px 100px;
}
.globalViewNotification .intenNotification {
    padding: 20px;
    border-radius: 5px;
}
.globalViewNotification .v-expansion-panels--variant-accordion > .v-expansion-panel {
    margin-top: 0;
}
.globalViewNotification .v-expansion-panel__shadow {
    box-shadow: none;
}
.globalViewNotification .v-expansion-panel .v-expansion-panel__shadow {
    display: none;
}
.globalViewNotification .v-expansion-panel {
    margin: 10px 0px;
}
.globalViewNotification .v-expansion-panel.v-expansion-panel--active span.count {
    display: none;
}
.globalViewNotification .title_accordion {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.globalViewNotification  span.count {
    font-size: 10px;
    color: gray;
}
.globalViewNotification  .v-expansion-panel-text__wrapper {
    color: gray;
    text-align: left;
}
.globalViewNotification  .title {
    padding: 0px 20px;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
}

.globalViewNotification .title h3 {
    margin: 0;
}

.globalViewNotification .title-actions {
    display: flex;
    gap: 0.5rem;
}

@media (max-width: 768px) {
    .globalViewNotification .title {
        flex-direction: column;
        text-align: center;
    }
    
    .globalViewNotification .title-actions {
        justify-content: center;
    }
}
.globalViewNotification  .title_accordion span {
    font-weight: 700;
}

.globalViewNotification .notification-status {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.globalViewNotification .read-notification {
    opacity: 0.7;
    background-color: #f5f5f5;
}

.globalViewNotification .read-notification .title_accordion span:first-child {
    color: #666;
}

.globalViewNotification .read-icon {
    margin-left: 0.5rem;
}

.globalViewNotification.dark .read-notification {
    background-color: #2a2a2a;
}

.globalViewNotification.dark .read-notification .title_accordion span:first-child {
    color: #999;
}
.autor {
    margin-top: 50px;
    display: flex;
    align-items: baseline;
}
span.logo {
    width: 30px;
    height: 30px;
    position: inherit;
    display: block;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background-color: #3b2d70;
    margin-right: 10px;
}
span.name {
    margin-top: auto;
    margin-right: 10px;
    margin-left: inherit;
    font-weight: 600;
}
span.date {
    font-size: 10px;
    color: gray;
}
.globalViewNotification.dark {
    background-color: black;
    color: white;
}
.globalViewNotification.dark .title {
    color: white;
}
.globalViewNotification.dark  .v-expansion-panel.v-expansion-panel {
    background-color: #373737;
    color: white;
}
.globalViewNotification.dark .v-expansion-panel-text__wrapper {
    text-align: left;
    color: white;
}
.v-expansion-panel-text__wrapper {
    color: gray;
}
@media (max-width: 600px) {
    .globalViewNotification {
        padding: 10px;
    }
}
.globalViewNotification  {
  min-height: 88vh;
}
.noNotification h3 {
    color: gray;
    font-size: 16px;
}
.noNotification  {
    margin-top: 50px;
}
.globalViewNotification  .countDataContent {
    font-size: 10px;
    color: gray;
}

/* Melhorias para visualização do conteúdo expandido */
.notification-content-wrapper {
    padding: 20px 0;
}

.notification-description {
    color: #374151;
    line-height: 1.6;
    margin-bottom: 24px;
    font-size: 14px;
}

.notification-description :deep(p) {
    margin: 0 0 12px 0;
    color: #374151;
}

.notification-description :deep(ul) {
    margin: 0 0 12px 0;
    padding-left: 20px;
}

.notification-description :deep(li) {
    margin-bottom: 6px;
    color: #374151;
}

.notification-description :deep(h1),
.notification-description :deep(h2),
.notification-description :deep(h3),
.notification-description :deep(h4),
.notification-description :deep(h5),
.notification-description :deep(h6) {
    margin: 16px 0 8px 0;
    color: #1f2937;
    font-weight: 600;
}

.notification-description :deep(strong) {
    font-weight: 600;
    color: #1f2937;
}

.notification-description :deep(a) {
    color: #6366f1;
    text-decoration: none;
}

.notification-description :deep(a:hover) {
    text-decoration: underline;
}

.notification-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
    margin-top: 16px;
}

.notification-actions {
    display: flex;
    gap: 8px;
}

.action-btn {
    font-size: 12px;
    text-transform: none;
    font-weight: 500;
}

.notification-meta {
    display: flex;
    align-items: center;
    gap: 12px;
}

.notification-date {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
    background: #f3f4f6;
    padding: 4px 8px;
    border-radius: 6px;
}

/* Tema escuro para o conteúdo expandido */
.globalViewNotification.dark .notification-description {
    color: #e5e7eb;
}

.globalViewNotification.dark .notification-description :deep(p) {
    color: #e5e7eb;
}

.globalViewNotification.dark .notification-description :deep(li) {
    color: #e5e7eb;
}

.globalViewNotification.dark .notification-description :deep(h1),
.globalViewNotification.dark .notification-description :deep(h2),
.globalViewNotification.dark .notification-description :deep(h3),
.globalViewNotification.dark .notification-description :deep(h4),
.globalViewNotification.dark .notification-description :deep(h5),
.globalViewNotification.dark .notification-description :deep(h6) {
    color: #f9fafb;
}

.globalViewNotification.dark .notification-description :deep(strong) {
    color: #f9fafb;
}

.globalViewNotification.dark .notification-footer {
    border-top-color: #4b5563;
}

.globalViewNotification.dark .notification-date {
    background: #374151;
    color: #d1d5db;
}

/* Responsividade para o conteúdo expandido */
@media (max-width: 600px) {
    .notification-footer {
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
    }
    
    .notification-actions {
        width: 100%;
        justify-content: flex-start;
    }
    
    .notification-meta {
        width: 100%;
        justify-content: flex-start;
    }
}
</style>